__webpack_public_path__ = '/';
import Vue from 'vue';
if (process &&
	Object.prototype.hasOwnProperty.call(process, 'env') &&
	process.env.NODE_ENV == 'production'
) {
	Vue.config.devtools = false;
	Vue.config.performance = false;

	/*Vue.config.devtools = true;
	Vue.config.performance = true;
	Vue.config.productionTip = true;*/
} else {
	/*make sure to set this synchronously immediately after loading Vue
	Configure whether to allow vue-devtools inspection.
	This option’s default value is true in development builds and false in production builds.
	You can set it to true to enable inspection for production builds.*/
	Vue.config.devtools = true;
	/*Set this to true to enable component init, compile, render
	and patch performance tracing in the browser devtool performance/timeline panel.
	Only works in development mode and in browsers that support the performance.mark API.*/
	Vue.config.performance = true;
	//Set this to false to prevent the production tip on Vue startup.
	Vue.config.productionTip = false;
}
Vue.prototype.$urlBasePath = '/';

/*Vue.config.errorHandler = function (err, vm, info) {
	console.log('ERR', err);
	console.log('ERR', vm);
	console.log('ERR', info);
};*/

import App from '@module/Site.vue';

import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);


// Vuesax Component Framework
import Vuesax from 'vuesax';

Vue.use(Vuesax);

import axios from "@/axios.js";
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
	axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
Vue.prototype.$http = axios;

import * as axiosLib from 'axios';
Vue.prototype.$axiosLib = axiosLib;

import jQuery from "jquery";
window.$ = jQuery;
window.jQuery = jQuery;

import "@/http/requests/indexSite.js";

import '@module/../siteThemeConfig.js';

// ACL
import acl from '@/acl/aclSite';

import '@/globalComponents.js';

import router from '@/siteRouter';

import store from '@/storeSite/store';

import i18n from '@/i18n/i18n';

import '@/filters/filters';

import VeeValidate, {
	Validator
} from 'vee-validate';
import pt_BR from 'vee-validate/dist/locale/pt_BR';

Vue.use(VeeValidate, {
	inject: false
});
Validator.localize('pt_BR', pt_BR);


import VueLodash from 'vue-lodash';
import debounce from "lodash/debounce";
import cloneDeep from "lodash/cloneDeep";
Vue.use(VueLodash, {
	lodash: {
		debounce,
		cloneDeep
	}
});

// Vuejs - Vue wrapper for hammerjs
import {
	VueHammer
} from 'vue2-hammer';
Vue.use(VueHammer);

// Feather font icon
require('@assets/css/iconfont.css');

import "@fortawesome/fontawesome-free/css/all.css";
import { forEach } from 'lodash';
//import "@fortawesome/fontawesome-free/js/all.js";

//console.log(App.propsData, App);


import 'clockwork-browser/metrics';
import 'clockwork-browser/toolbar';

require('@/jquery.endless-scroll.js');

var mountEl = document.querySelector("#app");
mountEl.dataset.pageName = "root";
//console.log(mountEl.firstChild, mountEl.firstChild.tagName);
/*if (
	mountEl.firstChild &&
	mountEl.firstChild.tagName == "DIV" &&
	mountEl.firstChild.innerHTML &&
	mountEl.firstChild.innerHTML.toString().trim().length > 0
) {
	console.log('data', mountEl.firstChild.dataset);
	mountEl.dataset.textoTopo = mountEl.firstChild.innerHTML.toString();
}*/
if (mountEl.hasChildNodes() &&
	mountEl.childNodes &&
	mountEl.childNodes.length > 0
) {
	for (var child of mountEl.childNodes) {
		if (child && child.dataset) {
			if (child.dataset.hasOwnProperty('topoTexto') &&
				child.dataset.topoTexto == 1 &&
				child.tagName == "DIV" &&
				child.innerHTML &&
				child.innerHTML.toString().trim().length > 0
			) {
				mountEl.dataset.textoTopo = child.innerHTML.toString();
			} else if (child.dataset.hasOwnProperty('termosTeste') &&
				child.dataset.termosTeste == 1 &&
				child.tagName == "DIV" &&
				child.innerHTML &&
				child.innerHTML.toString().trim().length > 0
			) {
				mountEl.dataset.termosTeste = child.innerHTML.toString();
			} else if (child.dataset.hasOwnProperty('regraEstiloTeste') &&
				child.dataset.regraEstiloTeste == 1 &&
				child.tagName == "DIV" &&
				child.innerHTML &&
				child.innerHTML.toString().trim().length > 0
			) {
				mountEl.dataset.regraEstiloTeste = child.innerHTML.toString();
			} else if (child.tagName == "DIV" &&
				child.id == "anuncioData" &&
				child.dataset.hasOwnProperty('anuncioData') &&
				child.dataset.anuncioData
			) {
				//mountEl.dataset.anuncioData = child.dataset.anuncioData;
			}
		}
	}
}
//console.log(mountEl.dataset);
console.log("ELEMENTO APP:", document.getElementById('app'));
new Vue({
	propsData: { ...mountEl.dataset },
	props: [
		"pageName",
		"topo",
		"textoTopo",
		"error",
		"errorTitle",
		"errorCode",
		"buttonTitle",
		"buttonLink",
		"recaptchaSitekey",
		"termosTeste",
		"regraEstiloTeste",
		"siteNome",
		"siteEmail",
		"siteEmpresa",
		"siteEnderecoEmail",
		"politicaPrivacidade",
		"anuncioData",
		"anunciosIdsData",
		"listaAnunciosData",
		"listaAnunciosHistoriaData",
		"listaAnunciosDisponivelData",
		"filListaTipoSexosData",
		"filListaTipoCategoriasData",
		"listaPrincipaisCidadesData",
		"listaPrincipaisPesquisasData",
		"filtrosData",
	],
	router,
	store,
	i18n,
	acl,
	render: h => h(App),
	created () {
		console.log(this.pageName, "CREATED");

		try {
			window.jQuery.support.historyState = (typeof history == 'object' && typeof history.pushState == 'function' && typeof history.replaceState == 'function' && typeof window.onpopstate == 'object');
		} catch (e) {
			window.jQuery.support.historyState = !1;
		}
		if (window.jQuery.support.historyState) {
			/*window.onpopstate = function (evt) {
				if (evt.state) {
					location.href = evt.state.url;
				}
			};*/
			/*if ('scrollRestoration' in history) {
				history.scrollRestoration = 'manual';
			}*/
		}
		try {
			window.jQuery.support.localStorage = ((!!Storage) && (typeof localStorage.setItem == 'function'));
		} catch (e) {
			window.jQuery.support.localStorage = !1;
		}
		if (window.jQuery.support.localStorage) {
			try {
				localStorage.setItem('testStorage', 1);
				localStorage.removeItem('testStorage');
			} catch (e) {
				window.jQuery.support.localStorage = !1;
			}
		}
		window.jQuery.support.passiveEvent = !1;
		try {
			var optsPassive = Object.defineProperty({}, 'passive', {
				get: function () {
					window.jQuery.support.passiveEvent = !0;
					return true;
				}
			});
			window.addEventListener("testPassive", null, optsPassive);
			window.removeEventListener("testPassive", null, optsPassive);
		} catch (e) {
			window.jQuery.support.passiveEvent = !1;
		}
		/*if (!$.support.positionFixed) {
			$('html').addClass('nofixed');
		}
		*/
		window.jQuery.isMobile = window.jQuery('html').hasClass('mobile');
		window.jQuery.isWebKit = (navigator.userAgent.toLowerCase().indexOf('webkit') > -1);
		window.jQuery.isIpad = ((navigator.userAgent.toLowerCase().indexOf('ipad') > -1) || (navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2));
		window.jQuery.isIOS = ((navigator.userAgent.toLowerCase().indexOf('iphone') > -1) || window.jQuery.isIpad);
		window.jQuery.isCrios = navigator.userAgent.toLowerCase().indexOf('crios') > -1;

		console.log('ids', window._anunciosIdsData);
		console.log('anun', window._listaAnunciosData);
		console.log('historia', window._listaAnunciosHistoriaData);
		console.log('disponivel', window._listaAnunciosDisponivelData);

		///console.log('created', typeof this.anuncioData, this.anuncioData, window._anuncioData);
		if (!this.filListaTipoSexosData && window._filListaTipoSexosData) {
			//this.filListaTipoSexosData = Object.assign({}, window._filListaTipoSexosData);
			if (typeof window._filListaTipoSexosData == "string") {
				this.filListaTipoSexosData = JSON.parse(window._filListaTipoSexosData);
			} else if (Array.isArray(window._filListaTipoSexosData)) {
				this.filListaTipoSexosData = window._filListaTipoSexosData;
			} else if (typeof window._filListaTipoSexosData == "object") {
				this.filListaTipoSexosData = Object.assign({}, window._filListaTipoSexosData);
			}
			window._filListaTipoSexosData = null;
			delete window._filListaTipoSexosData;
		}
		if (!this.filListaTipoCategoriasData && window._filListaTipoCategoriasData) {
			//this.filListaTipoCategoriasData = Object.assign({}, window._filListaTipoCategoriasData);
			if (typeof window._filListaTipoCategoriasData == "string") {
				this.filListaTipoCategoriasData = JSON.parse(window._filListaTipoCategoriasData);
			} else if (Array.isArray(window._filListaTipoCategoriasData)) {
				this.filListaTipoCategoriasData = window._filListaTipoCategoriasData;
			} else if (typeof window._filListaTipoCategoriasData == "object") {
				this.filListaTipoCategoriasData = Object.assign({}, window._filListaTipoCategoriasData);
			}
			window._filListaTipoCategoriasData = null;
			delete window._filListaTipoCategoriasData;
		}
		if (!this.listaPrincipaisCidadesData && window._listaPrincipaisCidadesData) {
			/*const userInfo = JSON.parse(document.getElementById("_listaPrincipaisCidadesData").text);
			console.log("User information: %o", userInfo);*/
			//this.listaPrincipaisCidadesData = Object.assign({}, window._listaPrincipaisCidadesData);
			if (typeof window._listaPrincipaisCidadesData == "string") {
				this.listaPrincipaisCidadesData = JSON.parse(window._listaPrincipaisCidadesData);
			} else if (Array.isArray(window._listaPrincipaisCidadesData)) {
				this.listaPrincipaisCidadesData = window._listaPrincipaisCidadesData;
			} else if (typeof window._listaPrincipaisCidadesData == "object") {
				this.listaPrincipaisCidadesData = Object.assign({}, window._listaPrincipaisCidadesData);
			}
			window._listaPrincipaisCidadesData = null;
			delete window._listaPrincipaisCidadesData;
		}
		if (!this.listaPrincipaisPesquisasData && window._listaPrincipaisPesquisasData) {
			//this.listaPrincipaisCidadesData = Object.assign({}, window._listaPrincipaisCidadesData);
			if (typeof window._listaPrincipaisPesquisasData == "string") {
				this.listaPrincipaisPesquisasData = JSON.parse(window._listaPrincipaisPesquisasData);
			} else if (Array.isArray(window._listaPrincipaisPesquisasData)) {
				this.listaPrincipaisPesquisasData = window._listaPrincipaisPesquisasData;
			} else if (typeof window._listaPrincipaisPesquisasData == "object") {
				this.listaPrincipaisPesquisasData = Object.assign({}, window._listaPrincipaisPesquisasData);
			}
			window._listaPrincipaisPesquisasData = null;
			delete window._listaPrincipaisPesquisasData;
		}
		if (!this.filtrosData && window._filtrosData) {
			if (typeof window._filtrosData == "string") {
				this.filtrosData = JSON.parse(window._filtrosData);
			} else if (Array.isArray(window._filtrosData)) {
				this.filtrosData = window._filtrosData;
			} else if (typeof window._filtrosData == "object") {
				this.filtrosData = Object.assign({}, window._filtrosData);
			}
			window._filtrosData = null;
			delete window._filtrosData;
		}
		if (!this.anunciosIdsData && window._anunciosIdsData) {
			this.anunciosIdsData = window._anunciosIdsData;
			window._anunciosIdsData = null;
			delete window._anunciosIdsData;
		}
		if (!this.listaAnunciosData && window._listaAnunciosData) {
			if (typeof window._listaAnunciosData == "string") {
				this.listaAnunciosData = JSON.parse(window._listaAnunciosData);
			} else if (Array.isArray(window._listaAnunciosData)) {
				this.listaAnunciosData = window._listaAnunciosData;
			} else if (typeof window._listaAnunciosData == "object") {
				this.listaAnunciosData = Object.assign({}, window._listaAnunciosData);
			}
			window._listaAnunciosData = null;
			delete window._listaAnunciosData;
		}
		if (!this.listaAnunciosHistoriaData && window._listaAnunciosHistoriaData) {
			if (typeof window._listaAnunciosHistoriaData == "string") {
				this.listaAnunciosHistoriaData = JSON.parse(window._listaAnunciosHistoriaData);
			} else if (Array.isArray(window._listaAnunciosHistoriaData)) {
				this.listaAnunciosHistoriaData = window._listaAnunciosHistoriaData;
			} else if (typeof window._listaAnunciosHistoriaData == "object") {
				this.listaAnunciosHistoriaData = Object.assign({}, window._listaAnunciosHistoriaData);
			}
			window._listaAnunciosHistoriaData = null;
			delete window._listaAnunciosHistoriaData;
		}
		if (!this.listaAnunciosDisponivelData && window._listaAnunciosDisponivelData) {
			if (typeof window._listaAnunciosDisponivelData == "string") {
				this.listaAnunciosDisponivelData = JSON.parse(window._listaAnunciosDisponivelData);
			} else if (Array.isArray(window._listaAnunciosDisponivelData)) {
				this.listaAnunciosDisponivelData = window._listaAnunciosDisponivelData;
			} else if (typeof window._listaAnunciosDisponivelData == "object") {
				this.listaAnunciosDisponivelData = Object.assign({}, window._listaAnunciosDisponivelData);
			}
			window._listaAnunciosDisponivelData = null;
			delete window._listaAnunciosDisponivelData;
		}
		if (!this.anuncioData && window._anuncioData) {
			//this.anuncioData = Object.assign({}, window._anuncioData);
			if (typeof window._anuncioData == "string") {
				this.anuncioData = JSON.parse(window._anuncioData);
			} else if (typeof window._anuncioData == "object") {
				this.anuncioData = Object.assign({}, window._anuncioData);
			}
			window._anuncioData = null;
			delete window._anuncioData;
		}
		window.jQuery('script[id="_listaAppData"]').remove();
	},
	mounted () {
		console.log(this.pageName, "MOUNTED");
	}
}).$mount('#app');
